import { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { IOpenDeal } from '../types';

export const initialState: IOpenDeal = {
    saveDealStatus: ApiRequestStatus.Idle,
    stateSnapshot: {},
    isDealSaveInProgress: false
};
